<template>
    <div>
        <h1 class="mb-2"><span class="text-blue">Rumah</span> <span class="text-red">Perindo</span></h1>
        <!-- <div class="text-red text-bold">Status Keanggotaan</div>
        <div class="text-bold">Terdaftar sebagai anggota Perindo DPD Jawabarat</div> -->
        <!-- <div v-if="!isMobile()">
        <img src="../../assets/images/peta.svg" alt="maps" class="mt-5">
        </div> -->
        <div class="lokasiMobile">
            <div class="buttons grid-2">
                <!-- <div class="search">
                    <div class="icon">
                    <i class="fas fa-search"></i>
                    </div>
                    <input type="text" placeholder="Cari Rumah Perindo">
                </div> -->
                <select name="dpw" id="dpw" v-model="province" @change="changeList($event)">
                    <!-- <option value="" disabled selected hidden>Pilih Kecamatan Tempat Tinggal</option> -->
                    <option v-for="(item) in provinceList" :key="item.prov_id" :value="item.prov_id"> {{item.prov_name}}
                    </option>
                    <!-- <option :value="11">Jawa Barat</option> -->
                </select>
            </div>
            <div class="wrapCard">
                <div v-if="isLoad" class="loadingio-spinner-spinner-acmdkw9v8mi">
                    <div class="ldio-xysc4s9ys08">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div class="grid-card" v-else>
                      <div class="card DPP" v-if="dppList">
                        <!-- <div class="imageCard">
                            <img src="../../assets/images/sc_rumahperindo.png" alt="">
                        </div> -->

                        <div class="body">
                            <div class="title mb-1 mt-1">{{dppList.dpp_name}}</div>
                            <div class="anggota text-small mb-1">
                                <div>KETUA UMUM : {{dppList.dpp_ketua}}</div>
                                <div>SEKRETARIS JENDERAL : {{dppList.dpp_sekretaris}}</div>
                                <div>BENDAHARA UMUM: {{dppList.dpp_bendahara}}</div></div>

                            <div class="alamat text-small mb-1">{{dppList.dpp_alamat}}</div>
                             <a :href="`https://www.google.com/maps?q=${dppList.dpp_latitude},${dppList.dpp_longitude}`" target="blank"> <button class="btn-fill blue petunjuk">Petunjuk Arah <i class="fas fa-paper-plane"></i>
                            </button></a>
                        </div>
                    </div>
                    <div class="card" v-for="(dpw, i) in dpwList" :key="i">
                        <!-- {{dpw.dpw_name}} -->
                        <!-- <div class="imageCard">
                            <img src="../../assets/images/sc_rumahperindo.png" alt="">
                        </div> -->

                        <div class="body">
                            <div class="title mb-1 mt-1">{{dpw.dpw_name}}</div>
                            <div class="anggota text-small mb-1">
                                <div>
                                    KETUA : {{dpw.dpw_ketua}}
                                </div>
                                <div> SEKRETARIS : {{dpw.dpw_sekretaris}}</div>
                                <div>BENDAHARA : {{dpw.dpw_bendahara}}</div></div>

                            <div class="alamat text-small mb-1">{{dpw.dpw_alamat}}</div>
                           <a :href="`https://www.google.com/maps?q=${dpw.dpw_latitude},${dpw.dpw_longitude}`" target="blank"> <button class="btn-fill blue petunjuk">Petunjuk Arah <i class="fas fa-paper-plane"></i>
                            </button></a>
                        </div>
                    </div>

                     <div class="card" v-for="(dpd, i) in dpdList" :key="i">
                         <!-- {{dpd}} -->
                        <!-- {{dpw.dpw_name}} -->
                        <!-- <div class="imageCard">
                            <img src="../../assets/images/sc_rumahperindo.png" alt="">
                        </div> -->

                        <div class="body">
                            <div class="title mb-1 mt-1">{{dpd.dpd_name}}</div>
                            <div class="anggota text-small mb-1">
                                <div>KETUA : {{dpd.dpd_ketua}}</div>
                                <div>SEKRETARIS : {{dpd.dpd_sekretaris}}</div>
                                <div>BENDAHARA : {{dpd.dpd_bendahara}}</div></div>

                            <div class="alamat text-small mb-1">{{dpd.dpd_alamat}}</div>
                             <a :href="`https://www.google.com/maps?q=${dpd.dpd_latitude},${dpd.dpd_longitude}`" target="blank">
                            <button class="btn-fill blue petunjuk">Petunjuk Arah <i class="fas fa-paper-plane"></i>
                            </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <button class="btnSelengkapnya">Lihat Lebih Banyak <i class="fas fa-chevron-down"></i></button> -->
        </div>
    </div>
</template>

<script>
import device from '../../mixins/isMobile'
import getAddress from '../../mixins/getAddress'
import axios from 'axios'
export default {
  mixins: [device, getAddress],
  async mounted () {
    document.title = 'Dashboard - Rumah Perindo'
    await this.selectProv()
    await this.getDPW()
  },
  data () {
    return {
      provinceList: null,
      province: 11,
      dpwList: null,
      dpdList: null,
      dppList: null,
      isLoad: false,
      dpwId: null
    }
  },
  methods: {
    async getDPW () {
      // this.logger('taiii')
      try {
        this.isLoad = true
        const dpwlist = await axios.get(`member/listdpw?prov_id=${this.province}`)
        this.dpwList = dpwlist.data.data
        this.logger(dpwlist.data, 'dpw kkkkk dataaaa')
        // this.logger(this.province, 'provinceeeeeeee')
        if (this.province === 11) {
          this.logger('fsdfs')
          this.getDPP()
        } else {
          this.dppList = null
        }
        // eslint-disable-next-line no-return-assign
        this.dpwList.forEach(element => this.dpwId = element.dpw_id)
        this.logger(this.dpwId, 'idDPW')
        this.getDPD()
        this.isLoad = false
      } catch (err) {
        this.isLoad = false
        this.logger(err)
      }
    },
    changeList (e) {
      // this.logger('/dasfadsfsd')
      this.profile = e.target.value
      this.getDPW()
    },
    async getDPP () {
      try {
        const dpplist = await axios.get('member/dpp')
        this.dppList = dpplist.data
        // this.logger(this.dppList, 'dpp')
      } catch (err) {
        this.logger(err)
      }
    },
    async getDPD () {
      try {
        const dpdList = await axios.get(`member/listdpd?dpw_id=${this.dpwId}&limit=3000`)
        this.dpdList = dpdList.data.data
        this.logger(this.dpdList.data, 'dpdList')
      } catch (err) {
        this.logger(err)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    h1 {
        @media only screen and (max-width: 600px) {
            font-size: 16px;
            margin-bottom: 2rem !important;
            margin-top: 2rem;
        }
    }

    img {
        width: 100%;
    }

    .lokasiMobile {
        .grid-2 {
            display: grid;
            grid-template-columns: 1fr 1fr;
            align-items: center;
            grid-column-gap: 1rem;
            grid-template-areas: "a b";

            @media only screen and (max-width: 600px) {
                grid-template-columns: 1fr;
            }

            #dpw {
                //  grid-area: b;
                margin-bottom: 2rem;
                margin-top: 2rem;
                max-width: 400px;
                &:focus{
                    outline: none;
                }
            }
        }

        .buttons {
            .search {
                display: flex;
                background-color: #fff;
                align-items: center;
                margin: 1rem 0;
                padding: 10px 10px;
                border-radius: 5px;
                box-shadow: 0 -0.5px 21.7px 0 rgba(33, 64, 154, 0.01), 0 100px 96px 0 rgba(33, 64, 154, 0.06);

                &:focus {
                    border: 1px solid $blue;
                }

                .icon {
                    width: 15%;
                    text-align: center;

                    i {
                        color: $blue;
                    }
                }

                input {
                    width: 85%;
                    border: none;
                    padding: 0;
                    color: $blue;

                    &:focus-visible {
                        outline: none;
                    }

                    &::-webkit-input-placeholder {
                        /* Chrome/Opera/Safari */
                        color: $blue;
                    }

                    &::-moz-placeholder {
                        /* Firefox 19+ */
                        color: $blue;
                    }

                    &:-ms-input-placeholder {
                        /* IE 10+ */
                        color: $blue;
                    }

                    &:-moz-placeholder {
                        /* Firefox 18- */
                        color: $blue;
                    }
                }
            }
        }

        select {
            background-color: $red;
            border: none;
            padding: 10px;
            border-radius: 5px;
            color: #fff;
            text-align: center;
            text-align-last: center;

            @media only screen and (max-width: 600px) {
                margin-bottom: 2rem;
            }
        }

        .wrapCard {
            position: relative;
        }

        .grid-card {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-gap: 1rem;
               @media only screen and (min-width: 1920px) {
                grid-template-columns: repeat(5, 1fr);
            }
            @media only screen and (min-width: 1440px)  and (max-width: 1919px) {
                grid-template-columns: repeat(4, 1fr);
            }
             @media only screen and (min-width: 800px)  and (max-width: 1024px) {
                grid-template-columns: repeat(3, 1fr);
            }
             @media only screen and (min-width: 500px)  and (max-width: 799px) {
                grid-template-columns: repeat(2, 1fr);
            }
            @media only screen and (max-width: 499px) {
                grid-template-columns: 1fr;
            }
            // position: relative;
        }

        .card {
            margin-bottom: 1rem;
            box-shadow: 0 9.7px 0 0 rgba(33, 64, 154, 0.03), 0 33px 67px 0 rgba(33, 64, 154, 0.08);

            .body {
                padding: 14px;

            }

            .imageCard {
                height: 120px;
                overflow: hidden;
            }

            .petunjuk {
                padding: 10px 1rem;
                border-radius: 20px;
                margin: 0 auto;

                i {
                    font-size: 12px;
                    margin: 0 5px;
                    color: $red;
                }
            }
        }
    }
</style>
